import {Injectable} from '@angular/core';
import {ApiCountryResponse} from './http/api-country-response';
import {Country} from './country';

@Injectable()
export class CountryService {

  constructor() {
  }

  public filterCountryList(countries: Array<Country>, filterValue: string): Array<Country> {
    return countries.filter(
      (country: ApiCountryResponse) => country.countryName.toLowerCase().includes(filterValue.toLowerCase()),
    );
  }

  public findByAlpha2CodeCountry(countries: Array<Country>, value: string): Country | null {
    const country = countries.find(
      (country: ApiCountryResponse) => country.alpha2Code.toLowerCase().includes(value.toLowerCase()),
    );

    return country ? country : null;
  }
}
